// src/layout/HeaderMenu.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HeaderMenu = ({ formato }) => {
    const { t } = useTranslation();

    const piccoloFormatoItems = [
        { key: 'stampanti',              label: t('nav.print_machines'),        icon: 'stampanti.png' },
        { key: 'formati',                label: t('nav.sheet_formats'),         icon: 'fogli.png' },
        { key: 'supporti',               label: t('nav.supports'),              icon: 'carte.png' },
        { key: 'finiture',               label: t('nav.finishes'),              icon: 'finiture.png' },
        { key: 'parametri',              label: t('nav.parameters'),            icon: 'parametri.png' },
        { key: 'lavorazioni-accessorie', label: t('nav.accessory_operations'),  icon: 'lavorazioni-accessorie.png' },
        { key: 'regole',                 label: t('nav.rules'),                 icon: 'regole.png' },
        { key: 'inchiostri',             label: t('nav.inks'),                  icon: 'inchiostri.png' },
    ];

    const grandeFormatoItems = piccoloFormatoItems;

    let basePath = '';
    let items = [];

    if (formato === 'piccolo') {
        basePath = '/piccolo-formato';
        items = piccoloFormatoItems;
    } else if (formato === 'grande') {
        basePath = '/grande-formato';
        items = grandeFormatoItems;
    }

    if (items.length === 0) return null;

    // Piccolo/grande formato: rendering originale con PNG
    return (
        <div className="top-nav d-flex text-white p-2" style={{ overflowX: 'auto', flexWrap: 'nowrap', WebkitOverflowScrolling: 'touch' }}>
            {items.map((item) => (
                <NavLink
                    key={item.key}
                    to={item.to || `${basePath}/${item.key}`}
                    className={({ isActive }) =>
                        `d-flex flex-column align-items-center text-decoration-none px-3 py-2 mx-1 rounded flex-shrink-0
                    ${isActive ? 'topNavActiveItem' : 'text-dark'}`
                    }
                >
                    <img src={`/menu-icons/${item.icon}`} height="30" alt={item.label} />
                    <div style={{ fontSize: '0.75rem', whiteSpace: 'nowrap' }}>{item.label}</div>
                </NavLink>
            ))}
        </div>
    );
};

export default HeaderMenu;
